import USD from "../png/currency/USD Icon/USD.png";

export const UsdIcon = () => {

  return (
    <img className="h-[20px]" src={USD} alt="USD Icon" />
  )
}